export default "__VITE_ASSET__Cwsog4v$__";